import React from 'react'
import { getFiltrosModalMobileStyles } from '../utils/styles'
import Modal from 'react-modal'
import closeOptionsRazonModal from '../../assets/img/close-options-razon-modal.svg'

const OpcionesOrdenarMobileModal = (
  {
    isOpen,
    setIsOpen,
    onRequestClose,
    distanceToToModales,
    title = '',
    options = [],
    selectedOption = null,
    onSelectOption,
  }
) => {
  const closeModal = () => {
    if (setIsOpen) {
      setIsOpen(false)
    }

    if (onRequestClose) {
      onRequestClose()
    }
  }

  const getOptionLabel = (option) => {
    if (typeof option === 'string') {
      return option
    }

    return option.label || option.value
  }

  const getOptionValue = (option) => {
    if (typeof option === 'string') {
      return option
    }

    return option.value
  }

  const isSelectedOption = (option) => {
    if (!selectedOption) {
      return false
    }

    return getOptionValue(option) === getOptionValue(selectedOption)
  }

  const selectOption = (option) => {
    if (onSelectOption) {
      onSelectOption(option)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={getFiltrosModalMobileStyles(distanceToToModales)}
    >
      <div className="opciones-ordenar-mobile-modal-main-container">
        <div className="main-opciones-ordenar-title">
          {title}
        </div>

        <div className="opciones-ordenar-modal-area-seaparator">
        </div>

        <div className="razones-options-container">
          {options.length > 0 && options.map((option) => (
            <div
              className={`razon-option ${isSelectedOption(option) ? 'selected' : ''}`}
              key={option}
              onClick={() => selectOption(option)}
            >
              {getOptionLabel(option)}
            </div>
          ))}

          {options.length === 0 && (
            <div className="razon-option">
              Sin opciones disponibles
            </div>
          )}
        </div>

        <div className="opciones-ordenar-modal-area-seaparator close-separator">
        </div>

        <div className="close-opciones-ordenar-modal-container">
          <div className="close-opciones-ordenar-modal" onClick={closeModal}>
            <img src={closeOptionsRazonModal} alt="" />
          </div>
        </div>

      </div>
    </Modal>
  )
}

export default OpcionesOrdenarMobileModal